import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import './EditButton.scss';

const EditButton = ({
  onInvoked,
}) => (
  <button
    type="button"
    className="table-edit-button"
    onClick={() => {
      if (onInvoked) {
        onInvoked();
      }
    }}
  >
    <FontAwesomeIcon color="#34495e" icon={solid('edit')} size="1x" />
  </button>
);

EditButton.propTypes = {
  onInvoked: PropTypes.func.isRequired,
};

export default EditButton;
